﻿import {isNullOrEmpty, StringNamedValue} from "@2d-front-monorepo/core";
import React, {JSX, useMemo} from "react";
import {HtmlRequiredControlProps} from "./HtmlControlProps";
import LabeledControl from "./LabeledControl";
import {useLabeledControl} from "./LabeledControlData";

export interface SelectProps extends Omit<HtmlRequiredControlProps<HTMLSelectElement>, "value"> {
	items: StringNamedValue[];
	placeholder?: string;
	multiple?: boolean;
	value?: string | string[];
}

export default function Select(props: SelectProps): JSX.Element {
	const {
		label,
		name,
		value,
		id,
		column,
		disabled,
		hidden,
		onChange,
		onBlur,
		onClick,
		ref,

		required,
		hint,
		error,
		inlineError,

		items,
		placeholder,
		multiple
	} = props;

	const {componentId, ariaRef} = useLabeledControl(id, hint, error);
	const itemsWithPlaceholder = useMemo(() => {
		if (isNullOrEmpty(placeholder)) {
			return items;
		}

		return [{label: placeholder, value: ""}, ...items];
	}, [items, placeholder]);
	const selectValue = multiple
		? (Array.isArray(value) ? value : value == null || value === "" ? [] : [value])
		: (Array.isArray(value) ? value[0] ?? "" : value);

	if (hidden) {
		return <></>;
	}

	return <LabeledControl label={label} type="select" id={componentId} required={required} column={column} error={error} inlineError={inlineError} disabled={disabled}
	                       clickable={disabled && onClick != null}
	                       hint={hint} hidden={hidden} ariaRef={ariaRef}>
		<select
			ref={ref}
			id={componentId}
			onChange={onChange}
			onBlur={onBlur}
			onClick={onClick}
			name={name}
			value={onChange == null ? undefined : selectValue}
			defaultValue={onChange == null ? selectValue : undefined}
			required={required}
			multiple={multiple}
			size={multiple ? undefined : 1}
			aria-describedby={ariaRef.current?.describedBy}
			aria-invalid={ariaRef.current?.invalid}
			aria-required={required}
			disabled={disabled}
			tabIndex={disabled ? -1 : undefined}>
			{itemsWithPlaceholder.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
		</select>
	</LabeledControl>;
};
